import React from 'react';
import { IconsPros } from './types';

/**
 * Play Icon component
 *
 * @returns JSX.ELEMENT
 */
export const PlayIcon = ({ 'data-testid': dataTestId }: IconsPros) => {
  return (
    <svg viewBox="0 0 16 16" data-testid={dataTestId}>
      <path d="M0,14.38V1.62A1,1,0,0,1,1.45.72L14.21,7.11a1,1,0,0,1,0,1.79L1.45,15.28A1,1,0,0,1,0,14.38Z" />
    </svg>
  );
};
